/* eslint-disable max-lines */
export const CAST_MEASUREMENTS = [
    // Body
    {
        indicator: 'A',
        text: 'Collar/Neck Base',
        key: 'collar_or_neck_base',
        value: 0,
        category: 'body'
    },
    {
        indicator: '',
        text: 'Shoulder Circumference',
        key: 'shoulder_circumference',
        value: 0,
        category: 'body'
    },
    {
        indicator: 'B',
        text: 'Across Shoulder Front',
        key: 'across_shoulder_front',
        value: 0,
        category: 'body'
    },
    {
        indicator: 'C',
        text: 'Across Chest Front',
        key: 'across_chest_front',
        value: 0,
        category: 'body'
    },
    {
        indicator: '',
        text: 'Across Chest Front 2 (Side to Side)',
        key: 'across_chest_front_2_side_to_side',
        value: 0,
        category: 'body'
    },
    {
        indicator: 'D',
        text: 'Shoulder Seam',
        key: 'shoulder_seam',
        value: 0,
        category: 'body'
    },
    {
        indicator: 'E',
        text: 'Bust or Chest',
        key: 'bust_or_chest',
        value: 0,
        category: 'body'
    },
    {
        indicator: 'F',
        text: 'Under Bust',
        key: 'under_bust',
        value: 0,
        category: 'body'
    },
    {
        indicator: 'G',
        text: 'Waist',
        key: 'waist',
        value: 0,
        category: 'body'
    },
    {
        indicator: '',
        text: 'Waist At 50%',
        key: 'waist_at_50_percent',
        value: 0,
        category: 'body'
    },
    {
        indicator: 'H',
        text: 'High Hip',
        key: 'high_hip',
        value: 0,
        category: 'body'
    },
    {
        indicator: '',
        text: 'Distance High Hip From Waist',
        key: 'distance_high_hip_from_waist',
        value: 0,
        category: 'body'
    },
    {
        indicator: 'I',
        text: 'Low Hip',
        key: 'low_hip_largest',
        value: 0,
        category: 'body'
    },
    {
        indicator: '',
        text: 'Distance Low Hip From Waist',
        key: 'distance_low_hip_from_waist',
        value: 0,
        category: 'body'
    },
    {
        indicator: '',
        text: 'Hip At 8 in',
        key: 'hips_8_in',
        value: 0,
        category: 'body'
    },
    {
        indicator: '',
        text: 'Hip At Seat',
        key: 'hips_at_seat',
        value: 0,
        category: 'body'
    },
    {
        indicator: '',
        text: 'Hip 2 in Above Crotch',
        key: 'hips_at_crotch_plus2',
        value: 0,
        category: 'body'
    },
    {
        indicator: 'J',
        text: 'Shoulder Bust To Point',
        key: 'shoulder_to_bustpt',
        value: 0,
        category: 'body'
    },
    {
        indicator: 'K',
        text: 'Shoulder To Waist',
        key: 'shoulder_to_waist',
        value: 0,
        category: 'body'
    },
    {
        indicator: '',
        text: 'Halter 1',
        key: 'halter_1',
        value: 0,
        category: 'body'
    },
    {
        indicator: '',
        text: 'Halter 2',
        key: 'halter_2',
        value: 0,
        category: 'body'
    },
    {
        indicator: 'L',
        text: 'Bust Point To Bust Point',
        key: 'bust_pt_to_bust_pt',
        value: 0,
        category: 'body'
    },
    {
        indicator: 'M',
        text: 'CF Neck To Waist',
        key: 'cf_neck_to_waist',
        value: 0,
        category: 'body'
    },
    {
        indicator: '',
        text: 'Across Shoulder Back',
        key: 'across_shoulder_back',
        value: 0,
        category: 'body'
    },
    {
        indicator: '',
        text: 'Across Chest Back',
        key: 'across_chest_back',
        value: 0,
        category: 'body'
    },
    {
        indicator: '',
        text: 'Across Chest Back 2',
        key: 'across_chest_back_2_side_to_side',
        value: 0, category: 'body'
    },
    {
        indicator: '',
        text: 'CB Neck to Wrist (Not Bent)',
        key: 'cb_neck_to_wrist_not_bent',
        value: 0,
        category: 'body'
    },
    {
        indicator: 'N',
        text: 'Shoulder To Wrist',
        key: 'shoulder_to_wrist_right',
        value: 0,
        category: 'body'
    },
    {
        indicator: '',
        text: 'Shoulder To Fingertip',
        key: 'shoulder_to_fingertip',
        value: 0,
        category: 'body'
    },
    {
        indicator: 'O',
        text: 'Armscye',
        key: 'armscye',
        value: 0,
        category: 'body'
    },
    {
        indicator: 'P',
        text: 'Bicep (Not Flexed)',
        key: 'bicep_not_flexed_1',
        value: 0,
        category: 'body'
    },
    {
        indicator: '',
        text: 'Forearm',
        key: 'forearm',
        value: 0,
        category: 'body'
    },
    {
        indicator: 'Q',
        text: 'Wrist',
        key: 'wrist',
        value: 0,
        category: 'body'
    },
    {
        indicator: '',
        text: 'CB Neck To Waist',
        key: 'cb_neck_to_waist',
        value: 0,
        category: 'body'
    },
    {
        indicator: '',
        text: 'CB Neck To Seat',
        key: 'cb_neck_to_seat',
        value: 0,
        category: 'body'
    },
    {
        indicator: '',
        text: 'CB Neck To Knee',
        key: 'cb_neck_to_knee',
        value: 0,
        category: 'body'
    },
    {
        indicator: '',
        text: 'CB Neck To Floor',
        key: 'cb_neck_to_floor',
        value: 0,
        category: 'body'
    },
    {
        indicator: 'R',
        text: 'Waist To Knee (Outseam)',
        key: 'waist_to_knee_outseam',
        value: 0,
        category: 'body'
    },
    {
        indicator: 'S',
        text: 'Waist To Floor (Outseam)',
        key: 'waist_to_floor_outseam',
        value: 0,
        category: 'body'
    },
    {
        indicator: 'T',
        text: 'Inseam',
        key: 'inseam_right',
        value: 0,
        category: 'body'
    },
    {
        indicator: 'U',
        text: 'Thigh',
        key: 'thigh',
        value: 0,
        category: 'body'
    },
    {
        indicator: 'V',
        text: 'Below Knee',
        key: 'below_knee',
        value: 0,
        category: 'body'
    },
    {
        indicator: 'W',
        text: 'Calf',
        key: 'calf',
        value: 0,
        category: 'body'
    },
    {
        indicator: 'X',
        text: 'Ankle',
        key: 'ankle',
        value: 0, category: 'body'
    },
    {
        indicator: 'Y',
        text: 'Half Girth',
        key: 'half_girth',
        value: 0,
        category: 'body'
    },
    {
        indicator: 'Z',
        text: 'Full Girth',
        key: 'full_girth',
        value: 0,
        category: 'body'
    },

    // Head
    {
        indicator: '1',
        text: 'Ear To Ear',
        key: 'ear_to_ear',
        value: 0,
        category: 'head'
    },
    {
        indicator: '2',
        text: 'Temple To Temple',
        key: 'temple_to_temple',
        value: 0,
        category: 'head'
    },
    {
        indicator: '3',
        text: 'Head Circumference',
        key: 'head_circ',
        value: 0,
        category: 'head'
    },
    {
        indicator: '4',
        text: 'Hairline To Browline',
        key: 'hairline_to_browline',
        value: 0,
        category: 'head'
    },
    {
        indicator: '5',
        text: 'Hairline To Tip Of Nose',
        key: 'hairline_to_tip_of_nose',
        value: 0,
        category: 'head'
    },
    {
        indicator: '6',
        text: 'Forehead To Nape',
        key: 'forehead_to_nape',
        value: 0,
        category: 'head'
    },
    {
        indicator: '7',
        text: 'Hairline Across Nape',
        key: 'hairline_across_nape',
        value: 0,
        category: 'head'
    },
    {
        indicator: '8',
        text: 'Neck Length',
        key: 'neck_length',
        value: 0,
        category: 'head'
    },

    // Hand
    {
        indicator: '9',
        text: 'Finger Circumference 1',
        key: 'finger_circumference_1',
        value: 0,
        category: 'hand'
    },
    {
        indicator: '10',
        text: 'Finger Circumference 2',
        key: 'finger_circumference_2',
        value: 0,
        category: 'hand'
    },
    {
        indicator: '11',
        text: 'Hand Length',
        key: 'hand_length',
        value: 0,
        category: 'hand'
    },
    {
        indicator: '12',
        text: 'Hand Breadth',
        key: 'hand_breadth',
        value: 0,
        category: 'hand'
    },
    {
        indicator: '13',
        text: 'Hand Circumference 1',
        key: 'hand_circumference1',
        value: 0,
        category: 'hand'
    },
    {
        indicator: '14',
        text: 'Hand Circumference 2',
        key: 'hand_circumference2',
        value: 0,
        category: 'hand'
    },

    // Other
    {
        indicator: '',
        text: 'Weight (lbs)',
        key: 'weight_lbs',
        value: 0,
        category: 'other'
    },
    {
        indicator: '',
        text: 'Height',
        key: 'height_in',
        value: 0,
        category: 'other'
    },
    {
        indicator: '',
        text: 'Height (EISS)',
        key: 'eiss_height',
        value: 0,
        category: 'other'
    },
    {
        indicator: '',
        text: 'Right Shoe',
        key: 'r_shoe_size',
        value: 0,
        category: 'other'
    },
    {
        indicator: '',
        text: 'Left Shoe',
        key: 'l_shoe_size',
        value: 0,
        category: 'other'
    }
];

export const OPTIONAL_MEASUREMENTS = {
    'optional_head_1': '',
    'optional_head_2': '',
    'optional_head_3': '',
    'optional_1': '',
    'optional_2': '',
    'optional_3': '',
    'optional_4': '',
    'optional_5': '',
};
